import React from "react";

export function ProjectIndicator({project, className = ""}) {
    const color = project?.color;
    return (
        <span
            className={`flex align-items-center justify-content-center border-circle surface-100 text-500 flex-shrink-0 ${className}`}
            style={color ? {backgroundColor: color} : undefined}
            aria-hidden="true"
        >
            {!color && <i className="pi pi-folder"/>}
        </span>
    );
}

export function entityKey(entity) {
    return entity?.documentId ?? entity?.id ?? null;
}
